import { format, parseJSON } from 'date-fns';
import { format as formatWithTZ, utcToZonedTime } from "date-fns-tz";
import { logger } from '../utils/logger';

const defaultFormat = 'dd LLL yyyy';
export const formatDate = (date: number | string, formatString: string = defaultFormat) => {
  let _d;
  try {
    if (typeof date === 'string') {
      const parsedData = date.startsWith('{') ? parseJSON(date) : parseInt(date);
      _d = new Date(parsedData);
    } else {
      _d = new Date(date);
    }
  } catch (e) {
    return '';
  }

  return typeof _d?.valueOf() === 'number' ? format(_d, formatString) : '';
}

export const parseDate = (date: string): number => {
  try {
    return new Date(parseJSON(date)).valueOf();
  } catch (e) {
    return NaN;
  }
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const formatInTimeZone = (date: string | Date, fmt: string, tz: string) =>
  formatWithTZ(utcToZonedTime(date, tz), fmt, { timeZone: tz });

export const getCurrentSQLFormatDateTime = () => {
  return (new Date()).toISOString().split('T').join(' ').substring(0, 19)
}

export const formatTimeFromSeconds = (seconds: number) => {
  const SECONDS_IN_YEAR = 365 * 24 * 3600;
  const SECONDS_IN_MONTH = 30 * 24 * 3600; // Assuming 30 days per month
  const SECONDS_IN_DAY = 24 * 3600;
  const SECONDS_IN_HOUR = 3600;
  const SECONDS_IN_MINUTE = 60;
  if (seconds === 0) {
    return "0m";
  }

  const years = Math.floor(seconds / SECONDS_IN_YEAR);
  seconds %= SECONDS_IN_YEAR;

  const months = Math.floor(seconds / SECONDS_IN_MONTH);
  seconds %= SECONDS_IN_MONTH;

  const days = Math.floor(seconds / SECONDS_IN_DAY);
  seconds %= SECONDS_IN_DAY;

  const hours = Math.floor(seconds / SECONDS_IN_HOUR);
  seconds %= SECONDS_IN_HOUR;

  const minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
  const remainingSeconds = seconds % SECONDS_IN_MINUTE;

  // Collect the time components
  const timeComponents: string[] = [];
  if (years > 0) timeComponents.push(`${years}Y`);
  if (months > 0) timeComponents.push(`${months}M`);
  if (days > 0) timeComponents.push(`${days}d`);
  if (hours > 0) timeComponents.push(`${hours}h`);
  if (minutes > 0) timeComponents.push(`${minutes}m`);
  if (remainingSeconds > 0) timeComponents.push(`${remainingSeconds}s`);

  // Return only the first two components
  return timeComponents.slice(0, 2).join(' ');
}

export const diffFormatTimeFromSeconds = (seconds: number) => {
  const SECONDS_IN_HOUR = 3600;
  
  if (seconds === 0) {
    return "0";
  } else if (seconds === SECONDS_IN_HOUR) {
    return `${Math.ceil(seconds / SECONDS_IN_HOUR)}hr`
  } else if (seconds < SECONDS_IN_HOUR) {
    return `${Math.ceil(seconds / 60)}mins`
  }

  const hours = Math.ceil(seconds / SECONDS_IN_HOUR);
  return (`${hours}hrs`);
}


export const shortenYearFormatDate = (dateStr: number | string): string => {
  try {
    // Handle empty/undefined values
    if (dateStr === null || dateStr === undefined || dateStr === '') {
      return 'Invalid date';
    }

    // Convert to Date object
    const date = new Date(dateStr);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    // Format the valid date
    return new Intl.DateTimeFormat("en-US", { 
      month: "short", 
      day: "numeric", 
      year: "numeric" 
    }).format(date);
  } catch (error) {
    logger.error('Error formatting date:', error);
    return 'Invalid date';
  }
};